import React, { useRef } from 'react';
import { Box, Fade, Popover } from '@mui/material';
import { AnimatePresence, motion } from 'motion/react';

interface PatientAllergiesPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  /** Allergy view-model peek content. */
  content: React.ReactNode;
}

export const PatientAllergiesPopover: React.FC<PatientAllergiesPopoverProps> = ({
  anchorEl,
  open,
  onClose,
  onMouseEnter,
  onMouseLeave,
  content,
}) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  const handlePopoverEnter = () => {
    if (onMouseEnter) {
      onMouseEnter();
    }
  };

  const handlePopoverLeave = () => {
    if (onMouseLeave) {
      onMouseLeave();
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transitionDuration={200}
      sx={{
        pointerEvents: 'none',
        '& .MuiPopover-paper': {
          pointerEvents: 'auto',
          maxWidth: '90vw',
          mt: 0.5,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'borderColors.primary',
          boxShadow: 3,
        },
      }}
      slots={{ transition: Fade }}
    >
      <Box
        ref={popoverRef}
        onMouseEnter={handlePopoverEnter}
        onMouseLeave={handlePopoverLeave}
        sx={{ p: 0 }}
      >
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.15 }}
            >
              {content}
            </motion.div>
          )}
        </AnimatePresence>
      </Box>
    </Popover>
  );
};
